export const phoneNoRegEx = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

export const zipCodeRegEx = /^\d{5}(-\d{4})?$/;

export const emailRegEx = /\S+@\S+\.\S+/;